import React, { useEffect } from "react";
import particlesJS from "particles.js";

const DotAnimation = () => {
    useEffect(() => {
        window.particlesJS("particles-js", {
            particles: {
                number: {
                    value: 500,
                    density: {
                        enable: true,
                        value_area: 500,
                    },
                },
                color: {
                    value: "#ccc",
                },
                shape: {
                    type: "circle",
                    stroke: {
                        width: 0,
                        color: "#000000",
                    },
                    polygon: {
                        nb_sides: 5,
                    },
                },
                opacity: {
                    value: 0.5,
                    random: false,
                    anim: {
                        enable: false,
                        speed: 1,
                        opacity_min: 0.1,
                        sync: false,
                    },
                },
                size: {
                    value: 5,
                    random: true,
                    anim: {
                        enable: false,
                        speed: 40,
                        size_min: 0.1,
                        sync: false,
                    },
                },
                line_linked: {
                    enable: true,
                    distance: 50,
                    color: "#cccccc",
                    opacity: 0.4,
                    width: 1,
                },
                move: {
                    enable: true,
                    speed: 4,
                    direction: "none",
                    random: false,
                    straight: false,
                    out_mode: "out",
                    attract: {
                        enable: false,
                        rotateX: 600,
                        rotateY: 1200,
                    },
                },
            },
            interactivity: {
                detect_on: "canvas",
                events: {
                    onhover: {
                        enable: true,
                        mode: "repulse",
                    },
                    onclick: {
                        enable: true,
                        mode: "push",
                    },
                    resize: true,
                },
                modes: {
                    grab: {
                        distance: 100,
                        line_linked: { opacity: 1 },
                    },
                    bubble: {
                        distance: 100,
                        size: 40,
                        duration: 2,
                        opacity: 8,
                        speed: 3,
                    },
                    repulse: { distance: 100 },
                    push: { particles_nb: 4 },
                    remove: { particles_nb: 2 },
                },
            },
            retina_detect: true,
        });
    }, []);

    return (
        <div
            id="particles-js"
            className="dots-bg"
            style={{
                // width: "400px",
                // height: "400px",
                // backgroundSize: "cover",
                // backgroundPosition: "50% 50%",
                // borderRadius: "1000px",
                // position: "fixed",
                // top: 0,
                // left: 0,
                // zIndex: 1,
            }}
        ></div>
    );
};

// export default ParticlesBackground;


export default DotAnimation;
